<template>
  <DBox
    :id="'settings-accounting-tax_types_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('vat_territory')}`"
    @add_click="onAddClick"
  >
    <div class="cmp-settings-accounting-tax_types_list">
      <NTable
        :id="'settings-accounting-tax_types_list'"
        class="h2 dbox1"
        :headers="headers"
        :items="list"
        :config="tableConfig"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('vat_territory')">
              <span class="ut-link ut-text-accent5" @click="onEdit(item)">{{ item.vat_territory }}</span>
            </td>
            <td v-bind="tdcon('vat_territory_name')">
                <span>{{ item.vat_territory_name }}</span>
            </td>
            <td v-bind="tdcon('options')">
                <div class="dt-icon-container">
                    <img
                        @click.stop="(e) => deleteVatTerritory(item)"
                        src="static/icons/delete.svg"
                        class="dt-icon v5 s1"
                    />
                </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { createTV } from '../../../../models/text-value.model';

export default {
  components: {
    NTable,
    DBox
  },
  props: {
    accountingSettingsData: {
      type: Object,
      default: () => []
    }
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        fullHeight: true,
        footer: false
      })
    };
  },
  computed: {
    headers: function() {
      return [
        createTableHeader("vat_territory", {}),
        createTableHeader("vat_territory_name", {}),
        createTableHeader("options", { text:false , mw:30 }),
      ];
    },
    list: function() {
      return this.accountingSettingsData?.vat_territories || [];
    },
  },
  methods: {
    onAddClick: function() {
        this.$router.push({
            ...this.$route,
            query: {
            modal: "add_vat_territory"
            }
        });
    },
    onEdit:function(item){
      console.log(item)
      this.$router.push({
            ...this.$route,
            query: {
              modal: "edit_vat_territory",
              vat_territory_id:item.vat_territory_id
            }
        });
    },

    deleteVatTerritory:function(item){
        this.$emit("delete",item);
    } 
    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-accounting-tax_types_list {
  height: 100%;
  .dt-ntable {
    td {
      &.tax_deduction_text {
        .checkbox-container {
          width: min-content;
        }
      }
    }
  }
}
</style>
